import GenerateSearchQuery from '../models/helpers/generateSearchQuery.ts';
import { SearchResult } from '../models/search/searchResult.ts';
import { SearchParam } from '../models/searchParams/searchParam.ts';
import { TableSearchParam } from '../models/searchParams/tableSearchParam.ts';
import { ApiClient } from "./ApiClient.js";

const SearchController = {
    get: (searchParam: SearchParam, tableSearchParam: TableSearchParam) => {
        let url = `search/${tableSearchParam.offset}/${tableSearchParam.limit}${GenerateSearchQuery(searchParam)}`;
        return ApiClient.get(url);
    },
    getNutritionalValues: (entities: SearchResult[]) => {
        let url = `search/nutritionalValues`;
        return ApiClient.post(url, entities);
    }
};
export default SearchController;